import { ConnectionType } from "@/composables/connection/models/request.model";
import { NotificationModel } from "@/helpers/models/notification.model";
import User from "@/helpers/models/user.model";
import httpService from "@/services/http.service";
import storageService from "@/services/storage.service";
import utilService from "@/services/util.service";
import {
  collection,
  getDocs,
  getFirestore,
  limit,
  onSnapshot,
  orderBy,
  query,
  QuerySnapshot,
  startAfter,
  startAt,
  Unsubscribe,
  where,
} from "firebase/firestore";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
import moment from "moment";
import { computed, ref, watch } from "vue";
import { useRoute } from "vue-router";
import {
  trackEvent,
  trackError,
  startInteraction,
  endInteraction,
} from "@/helpers/tracking.helpers";
import { TYPE } from "vue-toastification";
import { TrackingEvents } from "@/helpers/enum";
import {useNotificationStore} from "@/components/notifications-old/stores/notification-new.store"

TimeAgo.addLocale(en);
const timeAgo = new TimeAgo("en-US");
let unSubscribe: Unsubscribe;
const notifications = ref<NotificationModel[]>([]);
const isNotificationsLoading = ref<boolean>(false);
const notificationExceptTypes = [];
const allUnReadCount = ref<any>(0);

const isAnyNotificationUnread = computed<boolean>(() => {
  return (
    notifications.value.filter(
      (x) =>
        !x.isRead &&
        !notificationExceptTypes?.includes(x.notificationType || "")
    ).length > 0
  );
});
const showMoreBtn = ref<boolean>(false);
const allTabs = ref([
  "All",
  "Requests",
  "Predictions",
  "Watchlists",
  // "Favorite Investments",
  "Top Stats",
  "Links",
  "Points",
  "Favorite Influencers",
  "Images",
  "Favorite Symbols",
  "Recommendations",
  "Social Accounts",
  "Bio",
  "Trader Types",
  "Highlight Stats Left",
  "Highlight Stats Right",
  "Playbooks",
  "Best Trades",
]);
const blockedUsersListing = computed(() =>
  storageService ? storageService.GetProperty("blockedUsers") : []
);
const currentTab = ref(allTabs.value[0]);
const page = ref<number>(0);
const count = ref<number>(20);
const unReadCount = ref<any>();
const chatMessagesNotifications = ref<any>([]);

export const NotificationComposables = () => {
  const clearNotifications = () => {
    if (unSubscribe) {
      unSubscribe();
    }
  };

  const FilteredArray = computed(() => {
    let filtered = [...notifications.value];

    if (blockedUsersListing.value?.length) {
      filtered = filtered.filter(
        (x) => !blockedUsersListing.value.includes(x.data.userId)
      );
    }

    if (currentTab.value == "Requests") {
      return filtered.filter(
        (x) =>
          // x.notificationType == "following" ||
          x.notificationType == "friendrequest" ||
          x.notificationType == "friendRequestAccepted" ||
          x.notificationType == "friends"
      );
    } else if (currentTab.value == "Playbooks") {
      return filtered.filter((x) => x.notificationType == "playbook");
    } else if (currentTab.value == "Predictions") {
      return filtered.filter((x) => x.notificationType == "predictions");
    } else if (currentTab.value == "Watchlists") {
      return filtered.filter((x) => x.notificationType == "watchlists");
    } else if (currentTab.value == "Favorite Investments" || currentTab.value == "Favorite Symbols") {
      return filtered.filter(
        (x) => x.notificationType == "favouriteInvestment" || x.notificationType == "favoriteSymbols"
      );
    } else if (currentTab.value == "Profit And Loss") {
      return filtered.filter((x) => x.notificationType == "profitAndLoss");
    } else if (currentTab.value == "Top Stats") {
      return filtered.filter((x) => x.notificationType == "topStats");
    } else if (currentTab.value == "Links") {
      return filtered.filter((x) => x.notificationType == "links");
    } else if (currentTab.value == "Points") {
      return filtered.filter((x) => x.notificationType == "points");
    } else if (currentTab.value == "Favorite Influencers") {
      return filtered.filter(
        (x) => x.notificationType == "favouriteInfluencer"
      );
    } else if (currentTab.value == "Images") {
      return filtered.filter((x) => x.notificationType == "images");
    } else if (currentTab.value == "Favorite Platforms") {
      return filtered.filter((x) => x.notificationType == "portfolio");
    } else if (currentTab.value == "Recommendations") {
      return filtered.filter((x) => x.notificationType == "recommendation");
    } else if (currentTab.value == "Social Accounts") {
      return filtered.filter((x) => x.notificationType == "socialLink");
    } else if (currentTab.value == "Bio") {
      return filtered.filter((x) => x.notificationType == "update user");
    } else if (currentTab.value == "Trader Types") {
      return filtered.filter((x) => x.notificationType == "traderType");
    } else if (currentTab.value == "Highlight Stats Right") {
      return filtered.filter(
        (x) => x.notificationType == "highlightStatsRight"
      );
    } else if (currentTab.value == "Highlight Stats Left") {
      return filtered.filter((x) => x.notificationType == "highlightStats");
    } else if (currentTab.value == "Playbooks") {
      return filtered.filter((x) => x.notificationType == "playbook");
    } else if (currentTab.value == "Best Trades") {
      return filtered.filter((x) => x.notificationType == "winningTrades");
    }
    return filtered;
  });

  const unreadCount = computed(() => {
    return notifications.value.filter(
      (x) =>
        (!x.isRead) &&
        !notificationExceptTypes?.includes(x.notificationType || "")
    ).length;
  });

  const unviewedItemsCount = computed(() => {
    return FilteredArray.value.filter(
      (item) =>
        
        !notificationExceptTypes?.includes(item.notificationType || "")
    ).length;
  });

  const notificationTypeMapping: Record<string, string> = {
    friendrequest: "Requests",
    // following: "Requests",
    friends: "Requests",
    friendRequestAccepted: "Requests",
    playbook: "Playbooks",
    predictions: "Predictions",
    watchlists: "Watchlists",
    favouriteInvestment: "Favorite Symbols",
    favoriteSymbols: "Favorite Symbols",
    profitAndLoss: "Profit And Loss",
    topStats: "Top Stats",
    links: "Links",
    points: "Points",
    favouriteInfluencer: "Favorite Influencers",
    images: "Images",
    portfolio: "Favorite Platforms",
    recommendation: "Recommendations",
    socialLink: "Social Accounts",
    "update user": "Bio",
    traderType: "Trader Types",
    highlightStatsRight: "Highlight Stats Right",
    highlightStats: "Highlight Stats Left",
    winningTrades: "Best Trades",
  };

  const notificationCounts = computed(() => {
    const newCounts: Record<string, number> = { All: 0 };

    for (const notification of notifications.value) {
      if ( notification?.isRead) continue;

      const type = notification.notificationType;
      const readableType = type ? notificationTypeMapping[type] : undefined;

      if (readableType) {
        // newCounts.All = (newCounts.All || 0) + 1;
        newCounts[readableType] = (newCounts[readableType] || 0) + 1;
      }
    }
    newCounts.All = allUnReadCount.value;

    return newCounts;
  });


    const markNotificationAsRead = (id: string) => {
    if (!id) return;
    const notificationStore = useNotificationStore();
    notificationStore.markAsRead([id]);

  };

  const showMore = () => {
    page.value = page.value + 1;
    getNotifications();
  };

  const getDb = () => {
    const db = getFirestore();
    return db;
  };

  const unregisterSubscribe = () => {
    notifications.value = [];
    if (unSubscribe) {
      unSubscribe();
    }
  };

  const changeTab = (tab: string) => {
    currentTab.value = tab;
  };

  var lastDoc: any;

  const listenNotifications = async () => {
    try {
      const interaction = startInteraction(TrackingEvents.listeningForNotifications);
      if (unSubscribe) {
        unSubscribe();
      }
      let response = await httpService.getNotificationSettings();
      var userId = storageService.user.value?._id;
      var createdOn = storageService.user.value?.createdOn;
      let snapshotInQuery = [userId];
      if (
        response &&
        response.data &&
        response.data.data &&
        response.data.data.receiveFrom &&
        response.data.data.receiveFrom.public
      ) {
        snapshotInQuery.push("public");
      }
      if (userId) {
        isNotificationsLoading.value = true;
        const db = getDb();
        if (createdOn) {
          var q = query(
            collection(db, "notifications"),
            where("userId", "in", snapshotInQuery),
            where("createdOn", ">", createdOn.toString()),
            orderBy("createdOn", "desc")
          );
        } else {
          var q = query(
            collection(db, "notifications"),
            where("userId", "in", snapshotInQuery),
            orderBy("createdOn", "desc")
          );
        }
        if (lastDoc) {
          let d = lastDoc.data();
          q = query(q, where("createdOn", ">", d.createdOn.toString()));
        }
        unSubscribe = onSnapshot(q, (querySnapshot) => {
          isNotificationsLoading.value = false;
          trackEvent(TrackingEvents.notificationReceived, {
            count: querySnapshot.docs.length
          });
          handleNotificationResponse(querySnapshot, false);
        });
        endInteraction(interaction);
      }
    } catch (e: any) {
      trackError(e, {
        context: TrackingEvents.listeningForNotifications,
        userId: storageService.user.value?._id
      });
    }
  };

  const getNotifications = async () => {
    try {
      const interaction = startInteraction(TrackingEvents.loadNotifications);
      notifications.value = [];
      if (unSubscribe) {
        unSubscribe();
      }
      let response = await httpService.getNotificationSettings();
      var userId = storageService.user.value?._id;
      var createdOn = storageService.user.value?.createdOn;
      let snapshotInQuery = [userId];
      if (
        response &&
        response.data &&
        response.data.data &&
        response.data.data.receiveFrom &&
        response.data.data.receiveFrom.public
      ) {
        snapshotInQuery.push("public");
      }

      if (userId) {
        var countBefore = page.value * count.value;
        const db = getDb();
        if (createdOn) {
          var q = query(
            collection(db, "notifications"),
            where("userId", "in", snapshotInQuery),
            where("createdOn", ">", createdOn.toString()),
            orderBy("createdOn", "desc"),
            limit(100)
          );
        } else {
          var q = query(
            collection(db, "notifications"),
            where("userId", "in", snapshotInQuery),
            orderBy("createdOn", "desc"),
            limit(100)
          );
        }
        const querySnapshot = await getDocs(q);
        await handleNotificationResponse(querySnapshot);
        trackEvent(TrackingEvents.loadedNotifications, {
          count: querySnapshot.docs.length,
          tab: currentTab.value,
        });

        if (countBefore == 0) {
          lastDoc = querySnapshot.docs[0];
          listenNotifications();
        }
        endInteraction(interaction);
      }
    } catch (e: any) {
      trackError(e, {
        context: TrackingEvents.loadingNotifications,
        userId: storageService.user.value?._id
      });
    }
  };
  const filteredUsers = ref<any>([]);
  const fetchfilteredUsers = async() => {
    try {
      let query:any = null;
      query = `?type=myAll&page=1&count=100`;
      await httpService.getFilteredUser(query).then((res) => {
        if (res.data.isSuccess) {
          filteredUsers.value = res.data.data.list;
        }
      });
    } catch (error) {
     
    }
  }
  const handleNotificationResponse = async (
    querySnapshot: QuerySnapshot,
    handleMore: boolean = true
  ) => {
    const userId = storageService.user.value?._id;
    const newNotifications: NotificationModel[] = [];
    for (const doc of querySnapshot.docs) {
      let tempNotification = new NotificationModel();
      tempNotification = { ...doc.data() } as NotificationModel;
      
      const isRequestType = 
        tempNotification?.notificationType === "friendrequest" || 
        tempNotification?.notificationType === "following";

        
      const currentNotificationUser = isRequestType
        ? tempNotification.data.userId
        : tempNotification.data.connectionId || tempNotification.data.userId;

      if (currentNotificationUser === userId) {
        continue;
      }
      
      if (
        tempNotification?.notificationType == "update user" &&
        tempNotification?.data?.message.includes("has updated the bio")
      ) {
        tempNotification.data.message = "has updated their bio.";
      }

      let createdOn = doc.data().createdOn;
      tempNotification.createdOn = new Date(+createdOn).toISOString();
      tempNotification = updatedNotification(
        tempNotification,
        storageService.user.value
      );
      tempNotification._id = doc.id;

      if (
        tempNotification.notificationType === "post" ||
        tempNotification.notificationType === "tagged"
      ) {
        tempNotification.data.userProfilePicture =
          tempNotification.data.profilePicture;
      }

      tempNotification.data.profilePicture = utilService.getUserProfilePicture(
        tempNotification.data.userId!,
        tempNotification.data.userProfilePicture!,
        "male",
        false,
        false
      );

      tempNotification.data.momentTime = timeAgo.format(
        new Date(tempNotification.createdOn!)
      ) as string;

      if (tempNotification.notificationId) {
        const existIndex = notifications.value.findIndex(
          (x) => x.notificationId == tempNotification.notificationId
        );

        if (
          tempNotification.notificationType == ConnectionType.friendRequest &&
          tempNotification.data.requestStatus == "reject"
        ) {
          if (existIndex != -1) {
            notifications.value.splice(existIndex, 1);
          }
          continue;
        }

       if (existIndex == -1) {
          const userId = storageService.user.value?._id;
          if (
            tempNotification.notificationType !== ConnectionType.friendRequestAccepted &&
            tempNotification.data.userId !== userId
          ) {
            newNotifications.push(tempNotification);
          } else {
            newNotifications.push(tempNotification);
          }
        } else {
          newNotifications.push(tempNotification);
        }
      } else {
        const userId = storageService.user.value?._id;
        if (
          tempNotification.notificationType !== "friendRequestAccepted" &&
          tempNotification.data.userId !== userId
        ) {
          newNotifications.push(tempNotification);
        } else {
          newNotifications.push(tempNotification);
        }
      }
      
      // setTimeout(() => {
       
      // });
    }
    
    const seenNotificationIds = new Set();
    chatMessagesNotifications.value = [];
    notifications.value = [
      ...newNotifications,
      ...notifications.value.filter(
        (n) => !newNotifications.some((nn) => nn._id === n._id)
      ),
    ]
    .filter((notification, _, all) => {
      const id = notification.notificationId;
  
      // Skip if already processed
      if (seenNotificationIds.has(id)) {
        return false;
      }
      seenNotificationIds.add(id);
  
      // Remove "friends" if a matching "friendRequestAccepted" exists
      if (notification.notificationType === "friends") {
        const hasAccepted = all.some(
          (other) =>
            other.notificationType === "friendRequestAccepted" &&
            other.data.connectionId === notification.data.connectionId
        );
        return !hasAccepted;
      }
      if(notification.notificationType === 'chat') {
        chatMessagesNotifications.value.push(notification) 
        return false
      }
      return true
    })
    .sort(
      (a, b) =>
        new Date(b.createdOn!).getTime() - new Date(a.createdOn!).getTime()
    )
    setTimeout(() => {
      allUnReadCount.value = 0;
      notifications.value.forEach(notification => {
        const isRead = notification.isRead != undefined && notification.isRead != null && notification.isRead;
        if ( !isRead) allUnReadCount.value++;
        return notification
      });
    })

    if (handleMore && querySnapshot.docs.length >= count.value) {
      showMoreBtn.value = true;
    } else {
      showMoreBtn.value = false;
    }
  };



  const getType = (value: string): string | undefined => {
    let type = Object.entries(notificationTypeMapping).find(
      ([key, val]) => val === value
    )?.[0];
    type = getReadType(type);

    return type;
  };

  const getReadType = (type: any) => {
    if (type == "highlightStats") type = "highlightStatsLeft";
    if (type == "update user") type = "bio";
    if (type == "points") type = "lists";
    if (type == "winningTrades") type = "bestTrades";
    if (
      type == "following" ||
      type == "friends" ||
      type == "friendRequestAccepted"
    )
      type = "friendrequest";
    return type;
  };

  const friendRequestTypes = [
    "friendrequest",
    "following",
    "friends",
    "friendRequestAccepted",
  ];
  const doneRequestTypes = ref<any[]>([]);

  const markAllByType = async (notificationType: string | undefined) => {
    const interaction = startInteraction("MarkAllByType", {
      type: notificationType,
    });

    let type: string | undefined =
      notificationType || getType(currentTab.value) || "all";

    if (type === "friendrequest") {
      if (doneRequestTypes.value.length === friendRequestTypes.length) {
        endInteraction(interaction);
        return;
      }
      const remainingTypes = friendRequestTypes.filter(
        (item) => !doneRequestTypes.value.includes(item)
      );

      for (const item of remainingTypes) {
        if (!doneRequestTypes.value.includes(item)) {
          await markNotification(item);
          doneRequestTypes.value.push(item);
        }
      }
      endInteraction(interaction);
      return;
    }
    const userData = await markNotification(type);
    notifications.value = notifications.value?.map((tempNotification: any) => {
      const tempNotificationType = getReadType(tempNotification?.notificationType);
      setTimeout(() => {
        if(type == 'all') allUnReadCount.value = 0
        else if(tempNotification.isRead) allUnReadCount.value--;
      }, 100)
      if (tempNotificationType === type || type === 'all') {
        return updatedNotification(tempNotification, userData, true);
      }
      return tempNotification;
    });

    endInteraction(interaction);
  };

  const updatedNotification = (
    notification: NotificationModel,
    userData: any,
    isUpdateRequest: boolean = false
  ) => {
    const createdOn = notification.createdOn;
    let notificationType: string | undefined = notification?.notificationType;
    notificationType = getReadType(notificationType);
    var notificationReadTime: any = undefined;
    if (notificationType) {
      var notificationReadTime: any =
        userData?.notificationReadTime?.[notificationType];
      if (!notificationReadTime && userData?.notificationReadTime?.general) {
        notificationReadTime = userData?.notificationReadTime?.general;
      }
    }
    var readTime = +new Date("1/1/1970").toISOString();
    if (notificationReadTime) {
      readTime = +new Date(notificationReadTime);
    }

    notification.isRead = moment(readTime).isAfter(createdOn);

    return notification;
  };

  const markNotification = async (type: string) => {
    const interaction = startInteraction("MarkNotificationByType", { type });
    let user = storageService.user.value;
    const originalType = type;
    if (type == "requests") {
      type = "friendrequest";
    }
    try {
      const res = await httpService.readNotificationByType(type);
      if (res.data.isSuccess && user) {
        let responseReadTimes = res.data?.data?.notificationReadTime;
        if (
          type == "friendrequest" &&
          res.data?.data?.notificationReadTime?.friendrequest
        ) {
          const requestsReadTime =
            res.data?.data?.notificationReadTime?.friendrequest;
          friendRequestTypes.forEach((reqType: string) => {
            responseReadTimes[reqType] = requestsReadTime;
            notifications.value = notifications.value.map(
              (notifcation: any) => {
                if (notifcation.notificationType == reqType) {
                  notifcation.isRead = true;
                }
                return notifcation;
              }
            );
          });
        }
        user.notificationReadTime = {
          ...user.notificationReadTime,
          ...responseReadTimes,
        };
        storageService.setUser(user);
        trackEvent("NotificationsMarkedByType", {
          type,
          count: notifications.value.filter((n) => n.notificationType === type)
            .length,
        });

        const displayType = originalType === 'all' ? 'All notifications' : `${originalType.charAt(0).toUpperCase() + originalType.slice(1)} notifications`;
        utilService.showToast(`${displayType} marked as read successfully`, TYPE.SUCCESS);

        endInteraction(interaction);
        return user;
      } else {
        const displayType = originalType === 'all' ? 'all notifications' : `${originalType} notifications`;
        utilService.showToast(`Failed to mark ${displayType} as read`, TYPE.ERROR);
        endInteraction(interaction);
      }
    } catch (e: any) {
      trackError(e, {
        context: "Marking notifications by type",
        type,
      });

      const displayType = originalType === 'all' ? 'all notifications' : `${originalType} notifications`;
      utilService.showToast(`Failed to mark ${displayType} as read`, TYPE.ERROR);

      endInteraction(interaction);
    }
  };

  const markAllAsRead = () => {
    const interaction = startInteraction("MarkAllNotificationsRead");

    var ids: string[] = [];
    for (let item of notifications.value) {
      if (!item.isRead) {
        item.isRead = true;
        ids.push(item._id!);
      }
    }
    if (ids.length) {
      trackEvent("MarkAllNotificationsRead", {
        count: ids.length,
        tab: currentTab.value,
      });
      let user = storageService.user.value;
      httpService
        .readNotification(ids)
        .then((res) => {
          if (res.data.isSuccess && user) {
            user.notificationReadTime = res.data?.data?.notificationReadTime;
            storageService.setUser(user);
            trackEvent("MarkAllNotificationsReadSuccess", {
              count: ids.length,
            });
          }
          endInteraction(interaction);
        })
        .catch((e: any) => {
          trackError(e, {
            context: "Marking all notifications as read",
          });
          endInteraction(interaction);
        });
    } else {
      endInteraction(interaction);
    }
    unReadCount.value = ids.length;
  };

  const route = useRoute();
  const isPopoverVisible = ref(false);
  const notificationWrapperClicked = () => {
    isPopoverVisible.value = false;
  };
  watch(() => route?.path, notificationWrapperClicked);
  watch(() => isPopoverVisible.value, () => {
    console.log("isPopoverVisible",isPopoverVisible.value);
    if (!isPopoverVisible.value) {
      currentTab.value = "All";
    }
  });

  return {
    FilteredArray,
    changeTab,
    getNotifications,
    showMoreBtn,
    notifications,
    isAnyNotificationUnread,
    isNotificationsLoading,
    allTabs,
    currentTab,
    markNotificationAsRead,
    markAllAsRead,
    markAllByType,
    showMore,
    unregisterSubscribe,
    clearNotifications,
    notificationCounts,
    listenNotifications,
    isPopoverVisible,
    notificationWrapperClicked,
    unReadCount,
    unviewedItemsCount,
    unreadCount,
    chatMessagesNotifications,
  };
};
